import React, { useState } from "react";
import RadioGroup from "../../atoms/RadioGroup";

const TransactionType = ({
  selectedTypeOfTransaction,
  onSelectTypeOfTransaction,
}) => {
  const radioOptions = [
    { label: "Partially", value: "partially" },
    { label: "Fully", value: "fully" },
  ];

  const initialState = radioOptions.reduce((acc, { value }) => {
    acc[value] = false;
    return acc;
  }, {});

  const [radioStates, setRadioStates] = useState(initialState);

    // const handleRadioChange = (radioValue) => {
    //   setRadioStates((prevStates) => ({
    //     ...Object.keys(prevStates).reduce((acc, key) => {
    //       acc[key] = key === radioValue;
    //       return acc;
    //     }, {}),
    //   }));
    // };

  return (
    <div className="flex gap-8 pt-3 pb-2">
      <RadioGroup
        options={radioOptions.map(({ label, value }) => ({
          label,
          value,
        }))}
        value={selectedTypeOfTransaction}
        onChange={onSelectTypeOfTransaction}
      />
    </div>
  );
};

export default TransactionType;
